export const Cryptocoin = ({ width = '14', height = '14' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4120_38047)">
        <path
          d="M11.6111 7.88889C11.6111 8.47078 11.1375 8.94444 10.5556 8.94444H8.44444V6.83333H10.5556C11.1375 6.83333 11.6111 7.30699 11.6111 7.88889ZM10.5556 11.0556H8.44444V13.1667H10.5556C11.1375 13.1667 11.6111 12.693 11.6111 12.1111C11.6111 11.5292 11.1375 11.0556 10.5556 11.0556ZM19 10C19 15.2381 14.7381 19.5 9.5 19.5C4.26191 19.5 0 15.2381 0 10C0 4.76191 4.26191 0.5 9.5 0.5C14.7381 0.5 19 4.76191 19 10ZM12.8986 10C13.4047 9.43821 13.7222 8.70272 13.7222 7.88889C13.7222 6.14269 12.3018 4.72222 10.5556 4.72222V3.66667H8.44444V4.72222H5.27778V6.83333H6.33333V13.1667H5.27778V15.2778H8.44444V16.3333H10.5556V15.2778C12.3018 15.2778 13.7222 13.8573 13.7222 12.1111C13.7222 11.2973 13.4047 10.5618 12.8986 10Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4120_38047">
          <rect y="0.5" width="19" height="19" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
